import { createSuitMixin as e } from "../mixins/suit.js";
import { createWidgetMixin as i } from "../mixins/widget.js";
import n from "instantsearch.js/es/widgets/index/index";
export default {
  name: "AisIndex",
  mixins: [e({
    name: "Index"
  }), i({
    connector: function connector() {
      return n;
    }
  })],
  provide: function provide() {
    var e = this;
    return {
      $_ais_getParentIndex: function $_ais_getParentIndex() {
        return e.widget;
      }
    };
  },
  props: {
    indexName: {
      type: String,
      required: !0
    },
    indexId: {
      type: String,
      required: !1
    }
  },
  render: function render(e) {
    return e("div", {}, this.$slots.default);
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        indexName: this.indexName,
        indexId: this.indexId
      };
    }
  }
};